import {
  AdminSpinner,
  Button,
  Div,
  H3,
  Modal,
  ModalIconStyle,
  P,
  PropsModal,
  SuccessToast,
  TrashIcon,
  deleteManualOrder,
  useOrders,
  reportError,
} from '@vgrubs/components';
import { useState } from 'react';

export const DeleteOrderModal = ({ closeModal }: PropsModal) => {
  const [loading, setLoading] = useState(false);
  const {
    deleteManualOrderModal,
    setDeleteManualOrderModal,
    removeHistoryOrderById,
    removeOrderById,
  } = useOrders((state) => state);

  const order = deleteManualOrderModal;
  const id = order?.id;

  async function handleDeleteManualOrder() {
    if (!id) return;
    try {
      setLoading(true);
      const { data } = await deleteManualOrder(id);

      removeHistoryOrderById(order);
      removeOrderById(id);
      closeModal?.();
      setDeleteManualOrderModal(null);

      SuccessToast(data.message);
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && <AdminSpinner />}

      <Modal
        isOpen={!!deleteManualOrderModal}
        closeModal={closeModal}
        logo={false}
        zIndex={110}
      >
        <Div $flex $justifyCenter>
          <ModalIconStyle>
            <TrashIcon />
          </ModalIconStyle>
        </Div>
        <H3 $mb="8">Delete Order?</H3>
        <P $mb="16">Are you sure you want to delete this manual order?</P>

        <Div $flex $gap="20px">
          <Div $width="50%">
            <Button
              $selected
              $w="100%"
              $mt="24"
              onClick={handleDeleteManualOrder}
            >
              Yes
            </Button>
          </Div>
          <Div $width="50%">
            <Button
              $selected
              $gray
              $w="100%"
              $mt="24"
              onClick={() => setDeleteManualOrderModal(null)}
            >
              No
            </Button>
          </Div>
        </Div>
      </Modal>
    </>
  );
};
